import { endpoints } from './endpoints';

export const environment = {
  production: true,
  apiBaseUrl: 'https://gwt-qa1-nif65ti7gq-nw.a.run.app',
  baseUrl: 'https://reporting.workspace.training',
  endpoints: endpoints,
};
